import React from "react"

export const FavoriteStar = (props) => {
  let { isMyFavorite, className, onClick } = props

  const classNames = ["favorite-icon", className].filter(Boolean).join(" ")

  return (
    <div
      className={classNames}
      onClick={() => onClick()}
      data-is-favorite={isMyFavorite}
      data-cy={"favorite-star"}
    >
      <span className="glyphicon glyphicon-star" />
    </div>
  )
}
